import { CanActivateFn } from '@angular/router';
import { NO_ACCESS, accessGate } from './access-gate';
import { isTeamManager } from '../util/access-level';

/**
 * The group Owner only (Feature 4123): inviting members and changing their profiles is the
 * Owner's (and the platform admin's), never a configurable area. Another member — and a legacy
 * hotel account, Owner without any group (`isTeamManager`) — lands on Home with the "no access"
 * toast. Used next to the role guard — `[hotelManagerGuard, ownerGuard]` on `team/invite`; under
 * view-as the BE answers `[OWNER]` with the viewed group, so the admin passes. See `accessGate`.
 */
export const ownerGuard: CanActivateFn = accessGate(me => isTeamManager(me) ? 'admit' : NO_ACCESS);
